<template>
  <fragment>
    <CardModule untitle>
      <form
        ref="form"
        class="search-forms pa-2"
        @submit.prevent="filterSalesByAffiliate"
      >
        <v-row>
          <v-col cols="12" md="3" sm="4">
            <BaseTextField
              placeholder="Pesquisar"
              v-model="filter.pesquisar"
              @input="handleSearch"
              append-icon="mdi-magnify"
              single-line
              clearable
            ></BaseTextField>
          </v-col>
          <v-col cols="12" md="3" sm="4">
            <BaseSelect
              label="Status"
              v-model="filter.status"
              :items="status"
              item-text="text"
              item-value="value"
              clearable
            ></BaseSelect>
          </v-col>
          <v-col class="d-flex justify-end">
            <BaseButton
              variant="filter"
              type="submit"
              :loading="loadingSalesByAffiliateConsumer"
              >Filtrar</BaseButton
            >
          </v-col>
        </v-row>
      </form>

      <v-data-table
        class="table-body"
        no-data-text="Não há registros."
        loading-text="Buscando informações..."
        :headers="headers"
        :items="dataTable"
        :loading="loadingSalesByAffiliateConsumer"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :items-per-page="10"
        mobile-breakpoint="0"
        :header-props="{
          class: 'rounded-t-lg',
          color: $config.dados.corinputs,
        }"
        :footer-props="{
          class: 'rounded-b-lg',
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Vendas por página:',
        }"
      >
        <template v-slot:item.valor="{ item }">
          {{ formatCurrency(item.valor) || "-" }}
        </template>
        <template v-slot:item.dthr_pagamento="{ item }">
          {{ formatDateTime(item.dthr_pagamento) || "-" }}
        </template>
      </v-data-table>
    </CardModule>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import { formatCurrency, formatDateTime } from "@/utils";

import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseButton from "@/components/forms/BaseButton.vue";

export default {
  name: "SalesByAffiliateConsumer",
  props: {},
  components: {
    CardModule,
    BaseTextField,
    BaseSelect,
    BaseButton,
  },
  data() {
    return {
      formatCurrency,
      formatDateTime,
      filter: {
        pesquisar: "",
        status: "",
      },
      sortBy: "dthr_pagamento",
      sortDesc: true,
      headers: [
        {
          text: "Nome do Consumidor",
          value: "consumidor",
          align: "start",
          width: 200,
        },
        {
          text: "Data e Hora da Compra",
          value: "dthr_pagamento",
          align: "start",
          width: 200,
        },
        {
          text: "Status",
          value: "status",
          align: "start",
          width: 160,
        },
        {
          text: "Quantidade",
          value: "qtd_itens",
          align: "end",
          width: 100,
        },
        {
          text: "Valor",
          value: "valor",
          align: "end",
          width: 120,
        },
      ],
      status: [
        {
          text: "Pago",
          value: "PA",
        },
        {
          text: "Cancelado",
          value: "CA",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "userInfo",
      "salesByAffiliateConsumer",
      "loadingSalesByAffiliateConsumer",
    ]),
    dataTable() {
      return Object.values(this.salesByAffiliateConsumer).flat();
    },
  },
  methods: {
    ...mapActions(["fetchSalesByAffiliateConsumer"]),
    filterSalesByAffiliate() {
      let filter = {};

      if (this.filter.pesquisar) {
        Object.assign(filter, {
          pesquisar: this.filter.pesquisar,
        });
      }

      if (this.filter.status) {
        Object.assign(filter, {
          status: this.filter.status,
        });
      }

      Object.assign(filter, {
        idafiliado: this.userInfo.idafiliado,
      });

      this.fetchSalesByAffiliateConsumer(filter);
    },
    handleSearch: _.debounce(function (event) {
      this.filter.pesquisar = event;
      this.filterSalesByAffiliate();
    }, 500),
  },
  mounted() {
    this.fetchSalesByAffiliateConsumer({
      idafiliado: this.userInfo.idafiliado,
    });
  },
  destroyed() {
    this.filter = {
      pesquisar: "",
      status: "",
    };
  },
};
</script>

<style scoped></style>
